import '../css/profile.css';
import '../css/wa.css';
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { FaPlus, FaCheck, FaCamera, FaRegComment, FaRegHeart, FaTimes, FaTrashAlt } from "react-icons/fa";
import { useToast } from "../components/ToastProvider";
import { IoClose } from "react-icons/io5";

function MyPage() {
    const navigate = useNavigate();
    const [articleData, setArticleData] = useState([]);
    const [myData, setMyData] = useState([]);
    const [username, setUsername] = useState('');
    const [desc, setDesc] = useState('');
    const [profileImage, setProfileImage] = useState('');
    const [company, setCompany] = useState('');
    const [workDuration, setWorkDuration] = useState('');
    const [categories, setCategories] = useState([]);
    const [customCompanyInput, setCustomCompanyInput] = useState('');
    const fileInputRef = useRef(null);
    const [availableFields, setAvailableFields] = useState([]);
    const [availableCompanies, setAvailableCompanies] = useState([]);


    const [passwordField, setPasswordField] = useState('');
    const [newPasswordField, setNewPasswordField] = useState('');
    
    const showToast = useToast();

    useEffect(() => {
        let token = localStorage.getItem("token");
        if (!token) {
            navigate('/login');
            showToast("로그인하세요", { type: "info" });
            return;
        }
        
        const fetchMyData = async () => {
            document.getElementById('delete-popup').style.display = 'none';
            document.getElementById('change-popup').style.display = 'none';
            try {
                let { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/profile/my`, {
                    token
                });
                setArticleData(data.article);
                setMyData(data.myData);
                setUsername(data.myData.username);
                setProfileImage(data.myData.profile);
                setDesc(data.myData.desc);
                setCompany(data.myData.organ);
                setWorkDuration(data.myData.term || '');
                setCategories(JSON.parse(data.myData.category) || []);
            } catch (error) {
                showToast("데이터 로드 중 오류가 발생했습니다", { type: "error" });
            }
        };

        const fetchSignupData = async () => {
            try {
                const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/fetchsignupdata`, {
                });
                console.log(data);
                setAvailableFields(data.userCategory);
                setAvailableCompanies(data.userCompany);
            } catch (error) {
                // 에러 처리
            }
        };

        fetchMyData();
        fetchSignupData();
    }, [navigate]);
    
    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (!file.type.startsWith('image/')) {
            showToast("이미지 파일만 업로드 가능합니다", { type: "error" });
            return;
        }

        try {
            const img = new Image();
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            
            img.onload = () => {
                let width = img.width;
                let height = img.height;
                const maxSize = 150;

                if (width > height) {
                    if (width > maxSize) {
                        height = height * (maxSize / width);
                        width = maxSize;
                    }
                } else {
                    if (height > maxSize) {
                        width = width * (maxSize / height);
                        height = maxSize;
                    }
                }

                canvas.width = width;
                canvas.height = height;
                ctx.drawImage(img, 0, 0, width, height);

                const resizedImage = canvas.toDataURL('image/jpeg', 0.8);
                setProfileImage(resizedImage);
            };

            img.src = URL.createObjectURL(file);
        } catch (error) {
            showToast("이미지 처리 중 오류가 발생했습니다", { type: "error" });
        }
    };

    const handleCategorySelect = (category) => {
        if (categories.includes(category)) {
            // 이미 선택된 카테고리라면 제거
            setCategories(categories.filter(cat => cat !== category));
        } else if (categories.length < 3) {
            // 아직 3개를 선택하지 않았다면 추가
            setCategories([...categories, category]);
        } else {
            showToast("최대 3개의 분야만 선택할 수 있습니다", { type: "warning" });
        }
    };

    const handleCompanySelect = (companyName) => {
        setCompany(companyName);
    };

    const handleCustomCompanySubmit = () => {
        if (customCompanyInput.trim()) {
            setCompany(customCompanyInput.trim());
            setCustomCompanyInput('');
        }
    };

    const handleSave = async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) return;

            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/profile/my/update`, {
                desc,
                username,
                profile: profileImage,
                company,
                workDuration,
                categories,
                token
            });

            if (response.data.success) {
                showToast("프로필이 업데이트되었습니다", { type: "success" });
            }
        } catch (error) {
            showToast("저장 중 오류가 발생했습니다", { type: "error" });
        }
    };

    const toggleDelete = async (code, type) => {
        const token = localStorage.getItem("token");
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/delete`,
                {
                    token: token,
                    id: code,
                    type: type
                },
            );
            window.location.reload();
        } catch (error) {
            console.error("Failed to delete:", error);
        }
    };


    const changePassword = async () => {
        const token = localStorage.getItem("token");
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/change_password`,
                {
                    token: token,
                    prePassword: passwordField,
                    newPassword: newPasswordField
                },
            );
            document.getElementById('change-popup').style.display = 'none';

        } catch (error) {
            alert('비밀번호가 잘못되었습니다.')
        }
    };


    const deleteAccount = async () => {
        const token = localStorage.getItem("token");
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/delete_account`,
                {
                    token: token,
                    password: passwordField
                },
            );
            document.getElementById('change-popup').style.display = 'none';
            localStorage.removeItem('token')
            window.location.href = '/'
        } catch (error) {
            alert('비밀번호가 잘못되었습니다.')
        }
    };

    const toggleDeletePopup = () => {
        const deletePopup = document.getElementById('delete-popup');
        const changePopup = document.getElementById('change-popup');
    
        if (deletePopup.style.display === 'none' || deletePopup.style.display === '') {
            deletePopup.style.display = 'block';  // Change this to 'flex' if needed
            changePopup.style.display = 'none';
        } else {
            deletePopup.style.display = 'none';
        }
    };
    const toggleChangePopup = () => {
        const deletePopup = document.getElementById('delete-popup');
        const changePopup = document.getElementById('change-popup');
    
        if (changePopup.style.display === 'none' || changePopup.style.display === '') {
            changePopup.style.display = 'block';  // Change this to 'flex' if needed
            deletePopup.style.display = 'none';
        } else {
            changePopup.style.display = 'none';
        }
    };
    
    


    return (
        <div className='pf-center'>
            <div className='pf-main'>
                <div className='wa-card' style={{ marginTop: '15px', padding: '25px' }}>
                    <div className='pf-flex'>
                        <div className='pf-img wa-profile' onClick={() => fileInputRef.current.click()}>
                            <FaCamera className='pf-profile-change'/>
                            <img src={profileImage} alt="프로필" />
                            <input
                                type="file"
                                ref={fileInputRef}
                                onChange={handleImageUpload}
                                accept="image/*"
                                style={{ display: 'none' }}
                            />
                        </div>
                    </div>
                    
                    <input 
                        className='my-name' 
                        value={username} 
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    
                    <textarea 
                        className='my-desc' 
                        value={desc} 
                        maxLength="200" 
                        onChange={(e) => setDesc(e.target.value)}
                    />
                    
                    <div className='my-organ'>
                        <div className='company-section'>
                            <div className='section-title'>내 소속 회사</div>
                            <div className='field-tag-container'>
                                {availableCompanies.map((companyName, index) => (
                                    <div 
                                        key={index}
                                        className={`field-tag ${company === companyName ? 'selected' : ''}`}
                                        onClick={() => handleCompanySelect(companyName)}
                                    >
                                        {companyName}
                                    </div>
                                ))}
                            </div>
                            <div className='custom-company-input'>
                                <input
                                    type="text"
                                    value={customCompanyInput}
                                    onChange={(e) => setCustomCompanyInput(e.target.value)}
                                    placeholder="직접 입력하기"
                                    className="company-input"
                                />
                                <button 
                                    className="custom-company-button"
                                    onClick={handleCustomCompanySubmit}
                                    disabled={!customCompanyInput.trim()}
                                >
                                    추가
                                </button>
                            </div>
                            {company && (
                                <div className="company-selected">
                                    선택된 회사: <span>{company}</span>
                                    <button 
                                        onClick={() => setCompany("")}
                                        className="company-remove-btn"
                                    >
                                        <FaTimes />
                                    </button>
                                </div>
                            )}
                        </div>
                        <div className='work-duration'>
                            <div style={{display:'flex', alignItems:'center', gap:10}}>
                                <input
                                    type="text"
                                    value={workDuration}
                                    onChange={(e) => setWorkDuration(e.target.value)}
                                    placeholder="근무 기간"
                                    className="duration-input"
                                />
                                <span>년</span>
                            </div>
                        </div>
                    </div>

                    <div className="my-ctgr-section">
                        <div className='section-title'>내 분야 (최대 3개)</div>
                        <div className='field-tag-container'>
                            {availableFields.map((category, index) => (
                                <div 
                                    key={index}
                                    className={`field-tag ${categories.includes(category) ? 'selected' : ''}`}
                                    onClick={() => handleCategorySelect(category)}
                                >
                                    {category}
                                </div>
                            ))}
                        </div>
                        <div className="selected-categories-count">
                            {categories.length}/3 선택됨
                        </div>
                    </div>
                    <div className='pf-flex'>
                        <button className='pf-follow' onClick={handleSave}>
                            저장하기
                        </button>

                        <div className='pf-sub'>
                            <span onClick={toggleChangePopup}>비밀번호 변경하기</span>
                            <span onClick={toggleDeletePopup}>계정 삭제하기</span>
                        </div>

                    </div>
                </div>

                <div className='wa-card' style={{padding:10}}>
                    {articleData.map((article) => (
                        <div key={article.id} className='pf-at-box'>
                            <div className='pf-at-main' onClick={() => window.location.href = "/community/article/" + article.id}>
                                <div className='pf-at-title'>{article.title}</div>
                                <div className='pf-at-date'>{article.date}</div>
                            </div>
                            <div style={{marginLeft:'auto',display:'flex',gap:8}}>
                                <div className='pf-at-ct'>
                                    <FaRegHeart /> 
                                    {article.like}
                                </div>
                                <div className='pf-at-ct'>
                                    <FaRegComment />
                                    {article.commentCount}
                                </div>
                                <div className='pf-at-ct' onClick={() => toggleDelete(article.id, 'article')}>
                                    <FaTrashAlt />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>


            
            <div className='pf-popup' id='delete-popup'>
                <IoClose onClick={toggleDeletePopup} />
                <h2>계정 삭제하기</h2>
                <span>본인 확인을 위해, 비밀번호를 입력해주세요.</span>
                <input type='password'
                value={passwordField}
                onChange={(e) => setPasswordField(e.target.value)}
                ></input>
                <div className='pf-lct'>
                    <button onClick={deleteAccount}>
                        계정 삭제
                    </button>

                </div>
            </div>

            <div className='pf-popup' id="change-popup">
                <IoClose onClick={toggleChangePopup}/>
                <h2>비밀번호 변경하기</h2>
                <span>기존 비밀번호</span>
                <input type='password'
                value={passwordField}
                onChange={(e) => setPasswordField(e.target.value)}></input>
                <span>새로운 비밀번호</span>
                <input type='password'
                value={newPasswordField}
                onChange={(e) => setNewPasswordField(e.target.value)}></input>
                <div className='pf-lct'>
                    <button onClick={changePassword}>
                        비밀번호 변경
                    </button>

                </div>
            </div>
            
            
        </div>
    );
}

export default MyPage;